import React, { useMemo, useCallback } from 'react';
import { CollectionManagementHeader } from 'components/common/general/CollectionManagementPanel';
import { observer } from 'mobx-react-lite';
import { EmployeesStatusFilterDropdown } from 'components/common/add-employees/EmployeesStatusFilterDropdown';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { debounce } from 'global/utils/debounce';
import { useManageAddEmployeesPageStore } from 'store/pages/enrollment/manage-add-employees/pageStore';
import { AddEmployeesDropdown } from 'components/common/enrollment/add-employees/AddEmployeesDropdown';
import { SubscriberEnrollmentProgressFilterDropdown } from 'components/common/enrollment/add-employees/SubscriberEnrollmentProgressFilterDropdown';
import { useRootStore } from 'store/rootStore';
import { HeaderSectionStyled } from './styles';
import { TABLE_MANAGEMENT_PANEL_TEST_IDS } from '../constants';

export const TableManagementPanel: React.FC = observer(() => {
  const { paginationDelegate, employees } = useManageAddEmployeesPageStore();
  const { groupId, periodId } = useEnrollmentDomainParams();
  const { domainStoreV2 } = useRootStore();

  const debouncedSearch = useMemo(
    () =>
      debounce((searchValue: string) => {
        paginationDelegate.setFilterValue('employeeName', searchValue);
      }, 300),
    [paginationDelegate],
  );

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      debouncedSearch(e.target.value);
    },
    [debouncedSearch],
  );

  return (
    <CollectionManagementHeader
      data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.COLLECTION_MANAGEMENT_HEADER}
      elementsTitle="employees"
      page={paginationDelegate.page}
      currentElements={employees.length}
      elementsPerPage={12}
      totalElements={paginationDelegate.totalElements}
      onSearch={handleSearch}
      searchInputPlaceholder="Employee Name"
      headerSection={
        <HeaderSectionStyled>
          <AddEmployeesDropdown
            data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.ADD_EMPLOYEES_DROPDOWN}
            censusRedirectLink={`/manage-add-employees/census-upload/${groupId}/${periodId}`}
            availableAddEmployeesActions={domainStoreV2.availableAddEmployeesActions}
          />
          <EmployeesStatusFilterDropdown
            data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.EMPLOYEES_STATUS_FILTER_DROPDOWN}
            paginationDelegate={paginationDelegate}
          />
          <SubscriberEnrollmentProgressFilterDropdown paginationDelegate={paginationDelegate} />
        </HeaderSectionStyled>
      }
    />
  );
});
